import React from 'react';
import { UiLockStore } from '../../_flux/stores/ui_lock_store';
import { UiLock } from '../../_flux/components/ui_lock/ui_lock';
import { handleView } from '../handle_view';

const stores = {
    visible: UiLockStore,
};

const render = ({ visible }, options) =>
    <UiLock visible={visible} />;

export const init = (container, options) =>
    handleView(stores, render, options, container);
